import React from "react";

function InstantContact() {
  return (
    <div>
      <div className="container">
        <div className="instant-contact">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-4 m-auto">
              <a href="tel:+977 980-8011299" className="icons-vertical-card">
                <img
                  className="icons-vertical-card-icons"
                  src="../assets//icons/call-24px.svg"
                />
                <span className="icons-vertical-card-details">
                  <h4>Order Now</h4>
                  <p>+977 980-8011299</p>
                </span>
              </a>
            </div>
            <div className="col-12 col-md-4 col-lg-4 m-auto">
              <div className="icons-vertical-card">
                <img
                  className="icons-vertical-card-icons"
                  src="../assets//icons/access_time-24px.svg"
                />
                <span className="icons-vertical-card-details">
                  <h4>Schedules</h4>
                  <p>All-Day 10:00am-7:30pm</p>
                </span>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4 m-auto">
              <div className="icons-vertical-card">
                <img
                  className="icons-vertical-card-icons"
                  src="../assets//icons/location_on-24px.svg"
                />
                <span className="icons-vertical-card-details">
                  <h4>Free Delivery</h4>
                  <p>Aarubari, Tinchuli, Jorpati, Besigaon and Boudha.</p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  );
}

export default InstantContact;
